<template>
  <div class="main">
    <dd-header></dd-header>
    <div class="content_main">
      <h1>アップロード内容の確認</h1>
      <section class="confirm_sec">
        <h3>スケッチ画像</h3>
        <div class="img_list">
          <ul class="sketch_list">
            <li v-for="(image, index) in inputForm.upImgList" :key="'upimage-' + index"><img :src="image"></li>
          </ul>
        </div>
        <h3>コメント</h3>
        <div id="confirm_comment">{{inputForm.comment}}</div>
      </section>
      <section class="confirm_sec" id="upload_confirm">
        <h3>入力内容</h3>
        <ul>
          <li>
            <div>メールアドレス:</div>
            <div>{{inputForm.email}}</div>
          </li>
          <li>
            <div>氏名:</div>
            <div>{{inputForm.lastName}} {{inputForm.firstName}}</div>
          </li>
          <li>
            <div>氏名（カナ）:</div>
            <div>{{inputForm.lastNameKana}} {{inputForm.firstNameKana}}</div>
          </li>
          <li>
            <div>お届け先の郵便番号:</div>
            <div>{{inputForm.postcd}}</div>
          </li>
          <li>
            <div>連絡先電話番号:</div>
            <div>{{inputForm.tel}}</div>
          </li>
          <li>
            <div>設置場所について:</div>
            <div>{{locationLabel}}</div>
          </li>
          <li>
            <div>エレベーター有り:</div>
            <div>{{isElevetorFlg}}</div>
          </li>
        </ul>
      </section>
      <section class="scroll_rule">
        <dd-userule></dd-userule>
      </section>
      <div class="form_submit">
        <div class="cb">
          <input type="checkbox" name="consent" v-model="isPricyConsent">プライバシーポリシーと利用規約に同意する
        </div>
        <div class="action_area">
          <button type="button" @click="candel">戻る</button>
          <button type="button" @click="confirm" :class="{disabled : !isUploadEnable}">アップロード</button>
        </div>
      </div>
    </div>
    <dd-footer></dd-footer>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../utils/App'
import * as Api from '../utils/Api'
import {DC_URL, SO_STORAGE_KEY} from '../constants/App'
import Header from '../components/Header'
import Footer from '../components/Footer'
import LoadingModal from '../components/common/LoadingModal'
import UseRuleDetail from '../components/common/UseRuleDetail.vue'

export default {
  name: 'UploadConfirm',
  // props: {
  //   inputForm: Object
  // },
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-loading-modal': LoadingModal,
    'dd-userule': UseRuleDetail
  },
  data () {
    return {
      inputForm: {},
      locationList: [
        {id: 1, label: '集合住宅(1階)'},
        {id: 2, label: '集合住宅(２階以上)'},
        {id: 3, label: '一戸建て住宅(1階)'},
        {id: 4, label: '一戸建て住宅(２階以上)'},
        {id: 5, label: 'その他'}
      ],
      isPricyConsent: false
    }
  },
  computed: {
    isElevetorFlg: function () {
      if (this.inputForm.elevetorFlg) return 'あり'
      return 'なし'
    },
    locationLabel: function () {
      let location = this.locationList.filter(l => l.id === this.inputForm.location)
      return location ? location[0].label : ''
    },
    isUploadEnable: function () {
      if (this.isPricyConsent) {
        return true
      }
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    },
    candel: function () {
      this.$router.go(-1)
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.SKETCH + '/confirm', {}
      ).then(response => {
        this.$router.push({
          name: 'UploadComplete'
        })
        this.$refs.loadingModalRef.showModal(false)
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    }
  },
  mounted () {
  },
  created () {
    console.log('input form------------')
    // console.dir(this.inputForm)
    this.inputForm = App.getLocalStorage(SO_STORAGE_KEY.SKETCH_UPLOAD)
  }
}
</script>
<style src="../css/top.scss" lang="scss" scoped></style>
<style src="../css/main.scss" lang="scss" scoped></style>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/upload.scss" lang="scss" scoped></style>
<style src="../css/userule.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/UploadConfirm.vue